var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575 1641 c-52 -23 -101 -80 -115 -131 -6 -22 -10 -69 -8 -103 3 -62 3 -62 33 -62 l30 0 5 75 c4 57 11 84 29 108 45 64 27 62 614 62 l534 0 33 -22 c68 -47 71 -63 68 -350 -3 -242 -4 -258 -24 -285 -21 -28 -65 -54 -119 -70 l-30 -8 -3 -135 -3 -134 -137 137 -138 137 -264 -2 c-253 -3 -265 -4 -268 -22 -8 -41 19 -46 268 -46 l235 0 160 -160 c88 -88 167 -160 175 -160 35 0 40 21 40 176 l0 152 31 7 c45 10 125 91 138 140 15 55 15 516 0 566 -16 52 -64 108 -113 130 -38 17 -77 19 -586 19 -506 0 -548 -2 -585 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 1418 l3 -23 525 0 525 0 3 23 3 22 -531 0 -531 0 3 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 1168 c-28 -57 -56 -106 -61 -109 -5 -3 -52 -11 -106 -18 -162 -22 -166 -33 -49 -149 l84 -83 -20 -116 c-18 -107 -18 -116 -3 -132 16 -15 25 -12 124 41 l107 57 105 -55 c108 -56 140 -61 140 -21 0 12 -7 68 -17 125 l-17 102 82 83 c116 116 112 128 -45 147 -56 7 -106 16 -111 19 -5 3 -33 52 -61 109 -44 88 -55 102 -76 102 -21 0 -32 -14 -76 -102z m251 -189 l91 -12 -66 -67 -66 -67 14 -84 c8 -46 14 -86 12 -88 -2 -1 -34 13 -72 33 -37 20 -75 36 -85 36 -10 0 -50 -16 -88 -35 -38 -19 -71 -35 -73 -35 -2 0 2 33 9 73 7 39 13 80 13 90 1 11 -29 46 -65 80 l-66 62 93 15 94 15 40 82 40 81 42 -83 42 -83 91 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 1228 l3 -23 525 0 525 0 3 23 3 22 -531 0 -531 0 3 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897 1064 c-4 -4 -7 -16 -7 -26 0 -17 14 -18 236 -18 l235 0 -3 23 c-3 22 -3 22 -229 25 -124 1 -228 -1 -232 -4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidations);
export default __webpack_public_path__ + "static/media/validations.1fecf31a6d94ae4198a0eeb5543f7ce9.svg";
export { ForwardRef as ReactComponent };